import request from 'src/shared/utils/requester';

const USE_CASE_URL = 'customer-terms';

const updateCustomerTermById = async (body, customerTermId) => {
  const method = 'PUT';
  const url = `${USE_CASE_URL}/${customerTermId}`;

  const json = await request({ method, url, body });
  return json;
};

export default updateCustomerTermById;
